export const namespaced = true;

export const state = {
    
    travelPolicyAttributes: [],
}

export const mutations = {
    ADD_TRAVEL_POLICY_ATTRIBUTES(state, payload){
        state.travelPolicyAttributes=payload;
    },
}

export const actions = {
    addTravelPolicyAttributes(context, payload){
        context.commit('ADD_TRAVEL_POLICY_ATTRIBUTES', payload);
    }
}

export const getters = {}